import axiosInstance from 'src/utils/axios';

export const downloadPublicFile = async (url: string, fileName: string) => {
  try {
    const response = await axiosInstance.get('/download/public-file', {
      params: { url },
      responseType: 'blob',
    });

    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};
